import { ThemeUICSSObject } from '@apia/theme';

const tooltips: ThemeUICSSObject = {
  default: {
    border: '1px solid',
    borderColor: 'palette.border.field',
    background: 'palette.background.paper',
    color: 'palette.text.primary',
    padding: 3,
  },
};

export default tooltips;
